import { Col } from 'antd';
import styled from 'styled-components';
export const LeftMenu = styled(Col).attrs({
    xxl: 4,
    xl: 5,
    lg: 5
})`
  background: var(--gray-15);
  height: calc(-16px + 100vh);
  padding: var(--layout-03);
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-small) 0 0 var(--border-radius-small);

  h5 {
    margin-bottom: var(--spacing-05);
  }
`;
